export const DEFAULT_API_BASE_URL = "/api-proxy";
export const DEFAULT_SIGNALR_URL = "/api-proxy/hubs/device-status";
export const DEFAULT_STREAM_BASE_URL = "http://192.168.1.114:7104";

export function getApiBaseUrl(): string {
  return process.env.NEXT_PUBLIC_API_BASE_URL ?? DEFAULT_API_BASE_URL;
}

export function getSignalRUrl(): string {
  return process.env.NEXT_PUBLIC_SIGNALR_URL ?? DEFAULT_SIGNALR_URL;
}

export function getStreamBaseUrl(): string {
  return process.env.NEXT_PUBLIC_STREAM_BASE_URL ?? DEFAULT_STREAM_BASE_URL;
}

export function isMockDataEnabled(): boolean {
  return process.env.NEXT_PUBLIC_USE_MOCK === "true";
}

export function isSignalRDisabled(): boolean {
  return process.env.NEXT_PUBLIC_ENABLE_SIGNALR === "false";
}